import React, {Component} from 'react';
import {Button, Input, Modal, message} from "antd";
import {uuid, formatTime} from "../../../../utils";
import ActivitiModal from "../../../editor/components/activitiAndBtn/ActivitiModal";
import NormalModal from "./normalModal";
import {systemBaseEvent} from "../../../../base/baseEvent";

class AddModal extends NormalModal {
    version = 0;
    id = uuid();
    // 初始数据里面最少得有：当前人、当前部门、提交人
    formData = {
        creators: [window.top.currentUser.name],
    };

    constructor(props) {
        super(props);
        this.state = {
            visible: false,
            title: props.title,
            loadKey: uuid(),
            id: "",
            activityOption: {},//流程配置文件
        }
    }

    cleanData = () => {
        this.state.id = "";
        this.formData = {
            creators: [window.top.currentUser.name]
        };
        this.state.activityOption = {};
    };

    show(id) {
        this.cleanData();
        this.state.loadKey = uuid();
        if (id) {
            this.state.title = "修改" + this.props.pageType;
            this.state.id = id;
            this.detailsShow(id, (res) => {
                this.state.visible = true;
                this.initActivitiConfig(res);
            })
        } else {
            this.state.title = "新建" + this.props.pageType;
            this.formData = {};
            this.state.visible = true;
            this.initActivitiConfig({});
        }
    }

    //数据查询（根据Id)
    detailsShow = (id, call) => {
        let url = "";
        let method = "";
        let contentType = "";
        let body = null;
        this.props.sysConfigData.port.forEach((item) => {
            if (item.type === "get") {
                url = item.url;
                method = item.method;
                contentType = item.contentType;
                body = item.ajaxBody;
            }
        });
        this.request({
            url: url + id,
            method: method,
            contentType: contentType,
            body: body,
            callBack: (res) => {
                if (res) {
                    this.version = res.version;
                    this.formData = res;
                    call && call(res);
                }
            },
            errorCallBack: (e) => {
            },
        })
    };

    componentWillMount() {
    }

    componentDidMount() {
    }

    /**设置流程配置*/
    initActivitiConfig(story) {

        let id = story.id ? story.id : '';
        let that = this;
        let account = (window.currentUser && window.currentUser.account) ? window.currentUser.account : "";
        // 判断操作权限start
        let showBtnFlag = true;
        let pojoName = this.props.pojoName;
        let activitiConf = {type: this.props.activitiConfName};
        let againFlag = false;
        // 判断操作权限end
        this.state.activityOption = {
            ...this.state.activityOption,
            id: id,//流程id
            activitiConf,//流程conf
            pojoName: pojoName,//数据表name
            userAccount: account,//当前用户account
            showBtnFlag,//是否显示流程按钮
            againFlag,//重置流程的判断条件
            showAfterFuns: {},//流程按钮加载前置js
            getTextRequisite: false,//备注是否必填
            otherJs: {
                callActRevert: (activiti, buttonConf, call) => {
                    activiti.terminate.call(activiti, (res) => {
                        if (res) {
                            activiti.options.statusNameTemp = "草稿";
                            activiti.endFunction(activiti, function (res) {
                                if (res.status) {
                                    activiti.successMsg("流程已撤回，稿件变为草稿状态", function () {
                                        activiti.submitOK.call(activiti);
                                    });
                                }
                            })
                        }
                    });
                }
            },//流程按钮点击事件前置js
            saveFunction: that.save,//稿件保存方法
            saveStatusNameFunction: that.updateStatus,//稿件改流程状态方法
            onSubmitOK: function (activiti) {
                that.refresh(activiti)
            },//流程事件运行完毕的回调
            successCall: () => {
            },//流程加载完的回调
            readyCall: () => {
            },//流程初始化完的回调
            showRemarks: (remarks) => {
            },//备注回显
            onlyShowBtn: true,//是否只返回流程按钮
            title: '',//流程弹窗title
            visible: false,//流程弹窗是否展示
            mustNotShowPublishBtn: true, // 投稿编辑器中永远不显示发布按钮
            btnLoadOver: (btns) => {
            },
            showBtnIcon: true,
            btnType: "topicAndClue",
            checkForm: that.checkRule,
        };
        this.setState({});
    }

    allInputComponents = {};
    pushInputComponent = (componentName,inputComponent) => {
        if (inputComponent && this.allInputComponents) {
            this.allInputComponents[componentName] = inputComponent;
        }
    };

    //每个控件的数据校验
    customCheckData = () => {
        for(let inputKey in this.allInputComponents ) {
            let input = this.allInputComponents[inputKey];
            if (input && input.checkData) {
                if (!input.checkData(this.formData)) {
                    return false;
                }
            }
        }
        return true;
    };

    render() {
        let data = this.props.sysConfigData;
        this.convertBtn(data.btns);

        data.btns.map(item => {
            if (!item.onOk) {
                // 暂存时要求改为保存
                item.onOk = () => {
                    window.loading.show();
                    this.save(null, null, item.status, `${item.name === "暂存" ? "保存" : item.name}成功`);
                }
            }
        });
        let footer = this.buildFooterBtn(data.btns);
        if (data.activitiConfName && this.state.activityOption.pojoName) {
            footer.push(<ActivitiModal
                {
                    ...this.state.activityOption
                }
                key="activity-modal"
            />);
        }
        let id = `a-${this.id}-modal`;
        return (
            <Modal
                visible={this.state.visible}
                title={this.state.title}
                onOk={() => {
                    this.props.callBack && this.props.callBack();
                }}
                onCancel={() => {
                    this.setState({visible: false}, () => {
                        this.state.title = undefined;
                        systemBaseEvent.syncPlaybackExec("addModalOnCancelOver",)
                    })
                }}
                width={900}
                footer={footer}
                key={this.state.loadKey}
                maskClosable={false}
                height={data.height || (document.body.clientHeight * 0.8)}
            >
                <div id={id}>
                    {data.inputs.map((item, index) => {
                        return (
                            <div key={index} style={{display: "flex"}}>{
                                item.map((componentItem, _index) => {
                                    let ItemComponent = null;
                                    try {
                                        ItemComponent = require(`../formContent/${componentItem.component}.js`).default;
                                    } catch (e) {
                                        console.error(e);
                                        return <></>
                                    }
                                    let {field, refField} = componentItem.props;
                                    return (
                                        <ItemComponent ref={inputComponent => this.pushInputComponent(componentItem.component,inputComponent)}
                                                       key={index + "_" + _index} {...componentItem.props}
                                                       itemValue={this.formData[refField ? refField : field]}
                                                       callBack={(value) => {
                                                           if (field) {
                                                               this.formData[field] = value;
                                                               if (refField) {
                                                                   this.formData[refField] = value;
                                                               }
                                                               this.setState({}, () => {
                                                               })
                                                           }

                                                       }}/>
                                    );
                                })}
                            </div>
                        )

                    })}
                    <style>{`
                            #${id} .ant-form-item-label{
                                width: ${data.labelWidth || 100}px;
                                vertical-align: top
                            }
                        `}</style>
                </div>
            </Modal>
        );
    }

    //校验
    checkRule = (activiti, call) => {
        for (let i = 0; i < this.props.sysConfigData.inputs.length; i++) {
            let itemInput = this.props.sysConfigData.inputs[i];
            for (let j = 0; j < itemInput.length; j++) {
                let item = itemInput[j];

                if (item.props.empty) {
                    let field = item.props.field;
                    if (!this.formData[field]) {   // 判断输入框的里面的内容是否为空   数组在这块判断不出来
                        this.errorMessage(item);
                        return false;
                    } else {
                        if (this.formData[field] instanceof Array) {  // 是不是数组
                            if (!(this.formData[field] && this.formData[field].length)) {
                                this.errorMessage(item);
                                return false;
                            }
                        }
                        //newTimeCheck 证明要和当前时间做对比
                        if (item.props.newTimeCheck) {
                            let currentTime = formatTime(new Date());
                            let date = new Date(currentTime);
                            let newData = date.getTime();

                            if (this.formData[field] < newData) {
                                message.destroy();
                                message.warning(item.props.checkMessage);
                                window.loading.hide();
                                return false;
                            }
                        }
                    }
                }

            }
        }
        if (!this.customCheckData()) {
            window.loading.hide();
            return false;
        }
        // 如果校验通过则调用回调
        call && call();
        return true;
    };
    errorMessage = (item) => {
        let Mess;
        if (item.props.errorMessage) {
            Mess = item.props.errorMessage
        } else {
            Mess = "请输入" + item.props.label + "！";
        }
        message.destroy();
        message.warning(Mess);
        window.loading.hide();

    };

    //保存
    save = async (activiti, call, status = "草稿", msg = "操作成功！") => {
        // window.loading.show();
        // 校验
        let checkResult = this.checkRule();
        if (!checkResult) {
            window.loading.hide();
            call && call(false);
            return false;
        }
        // 取接口参数
        let url = "";
        let method = "";
        let contentType = "";
        let body = this.formData;
        this.props.sysConfigData.port.forEach((item) => {
            if (!body.id) {
                if (item.type === "add") {
                    url = item.url;
                    method = item.method;
                    contentType = item.contentType;
                }
            } else {
                if (item.type === "update") {
                    url = item.url + body.id;
                    method = item.method;
                    contentType = item.contentType;
                }
            }
        });
        if (!url || !method || !contentType) {
            window.loading.hide();
            call && call(false);
            return false;
        }
        // if (!body.id) {
            body.status = status;
        // }
        // // 新增加字段
        // if (!body.id && body.status === "草稿") {
        //     body.receiverIds && body.receiverIds.map(item => {
        //         item.status = "隐藏"
        //     })
        // }
        for(let inputKey in this.allInputComponents) {
            let inputComponent = this.allInputComponents[inputKey];
            if (inputComponent && inputComponent.listenSubmit && typeof inputComponent.listenSubmit === "function") {
                if (inputComponent.listenSubmit.constructor.name === "AsyncFunction") {//说明是异步方法
                    await inputComponent.listenSubmit(body);
                } else {
                    inputComponent.listenSubmit(body);
                }
            }
        }
        this.request({
            url: url,
            method: method,
            contentType: contentType,
            body: body,
            loading:false,
            callBack: (res) => {
                if (res) {
                    this.formData = res;
                    this.version = res.version;
                    this.state.id = res.id;
                    call && call(res);
                    if (!activiti) {//点击了暂存按钮
                        message.success(msg, 0.5, () => {
                            this.refresh(activiti);
                        });
                    }
                } else {
                    window.loading.hide();
                    message.error('操作失败！');
                    call && call(false);
                }
            },
            errorCallBack: (e) => {
                console.log(e.toString());
                window.loading.hide();
                message.error('操作失败！');
                call && call(false);
            },
        })
    };
    //修改状态
    updateStatus = (status, activiti, call) => {
        let {id} = this.state;
        if (!id) {
            call && call(false);
            return false;
        }
        // 校验
        let checkResult = this.checkRule();
        if (!checkResult) {
            window.loading.hide();
            call && call(false);
            return false;
        }

        // 取接口参数
        let url = "";
        let method = "";
        let contentType = "";
        this.props.sysConfigData.port.forEach((item) => {
            if (item.type === "update") {
                url = item.url;
                method = item.method;
                contentType = item.contentType;
            }
        });
        if (!url || !method || !contentType) {
            window.loading.hide();
            call && call(false);
            return false;
        }
        let params = {id, status, version: this.version};
        this.request({
            url: url + id,
            method: method,
            contentType: contentType,
            body: params,
            loading:false,
            callBack: function (res) {
                if (res) {
                    call && call({status: true, msg: "流程推进后状态修改成功。"});
                } else {
                    call && call({status: false, msg: "流程推进后状态修改失败。"});
                }
            },
            errorCallBack: function (e) {
                console.log(e.toString());
                call && call({status: false, msg: "流程推进后状态修改失败。"});
            }
        })
    }
}

export default AddModal;
